import { Component, inject } from '@angular/core';
import { SiteState } from '@next/core-lib/site';
import { Store, select } from '@ngrx/store';
import { selectSkalReport } from 'src/app/store/selectors';

@Component({
  selector: 'app-skal-report-quick-view',
  templateUrl: './skal-report-quick-view.component.html',
  standalone: false,
})
export class SkalReportQuickViewComponent {
  private readonly store = inject<Store<SiteState>>(Store);

  skalReport$ = this.store.pipe(select(selectSkalReport));
}
